import { z } from 'zod';
export const WEBHOOK_ACTIVITY_KINDS = {
    Fired: 'webhook.fired',
    Failed: 'webhook.failed',
};
export const WEBHOOK_ERROR_CODES = {
    Unauthenticated: 'WEBHOOK_UNAUTHENTICATED',
    Forbidden: 'WEBHOOK_FORBIDDEN',
    NotFound: 'WEBHOOK_NOT_FOUND',
    Invalid: 'WEBHOOK_INVALID',
    DeliveryFailed: 'WEBHOOK_DELIVERY_FAILED',
};
export const WebhookSubscription = z.object({
    id: z.string().uuid(),
    ownerId: z.string().uuid().nullable(),
    name: z.string(),
    targetUrl: z.string(),
    kinds: z.array(z.string()),
    enabled: z.boolean(),
    secretLastRotatedAt: z.string().datetime({ offset: true }).nullable(),
    lastDeliveryAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
});
export const WebhookDelivery = z.object({
    id: z.string().uuid(),
    subscriptionId: z.string().uuid(),
    activityId: z.string().uuid().nullable(),
    state: z.enum(['queued', 'delivered', 'failed', 'skipped']),
    attemptedAt: z.string().datetime({ offset: true }),
    statusCode: z.number().int().nullable(),
    error: z.string().nullable(),
    responseMs: z.number().int().nullable(),
});
//# sourceMappingURL=webhooks.js.map